'use strict';
export default {
  methods: {
    archivoPdfNorma (param) {
      return new Promise((resolve, reject) => {
        let respuesta = {
          finalizado: false,
          archivo: ''
        };
        this.$storage.set('token', process.env.TOKEN_EXTERNO);
        this.$service.get(`normativas/${param}`, {})
        .then(response => {
          this.$storage.remove('token');
          if (response) {
            respuesta.archivo = response.contenido;
            respuesta.finalizado = true;
          } else {
            reject(respuesta);
          }
          resolve(respuesta);
        }).catch(error => {
          console.log(error);
          reject(respuesta);
        });
        this.$storage.remove('token');
      });
    }
  }
};



// WEBPACK FOOTER //
// ./src/components/portal/mixins/normas.js